import { EmptyState } from "./EmptyState";
import { FileList } from "./FileList";
import { StepDetails } from "./StepDetails";
import { WorkflowFilesPanel } from "./WorkflowFilesPanel";

export function StepStoragePanel({
  spaceId,
  branch,
  volumeName,
  canWrite,
}: {
  spaceId: string;
  branch: { id: string; name: string; workflowId: string };
  volumeName: string | null;
  canWrite: boolean;
}) {
  return (
    <StepDetails
      heading={null}
      flushBody
      body={
        volumeName === null ? (
          <FileList title="Files">
            <EmptyState
              iconName="folder"
              title="No files yet"
              description="Files this step reads and writes will appear here."
            />
          </FileList>
        ) : (
          <WorkflowFilesPanel
            key={`${branch.id}/${volumeName}`}
            spaceId={spaceId}
            branch={branch}
            volumeName={volumeName}
            canWrite={canWrite}
          />
        )
      }
    />
  );
}
